import { commonUtils } from '../common_utils';

const KATTOKORKO_MIN_LOAN_AMOUNT = 500;
const KATTOKORKO_MAX_LOAN_AMOUNT = 100000;

export const kattokorko = {
    removeGreenEffect() {
        $('.greenFadeEffectKattokorko').removeClass('updateSec');
    },
    loadYear(defaultYears) {
        const $loanPeriod = $('#kattokorkoLoanPeriod').empty();
        for (let year = 1; year <= 18; year++) {
            $loanPeriod.append(new Option(year, year));
        }
        $loanPeriod.val(defaultYears);
    },
    slider() {
        const defaultYear = $('#kattokorkoLoanPeriod').val();
        const $loanAmountInput = $('#kattokorkoLoanAmount');
        let loanAmountValue = $loanAmountInput.val();

        $('.greenFadeEffectKattokorko').addClass('updateSec');

        if (loanAmountValue < KATTOKORKO_MIN_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.kattokorko_min_loan_amount);
            loanAmountValue = KATTOKORKO_MIN_LOAN_AMOUNT;
            $loanAmountInput.val(loanAmountValue);
        }

        if (loanAmountValue > KATTOKORKO_MAX_LOAN_AMOUNT) {
            alert(Translations.ad_detail.finance.error.kattokorko_max_loan_amount);
            loanAmountValue = KATTOKORKO_MAX_LOAN_AMOUNT;
            $loanAmountInput.val(loanAmountValue);
        }

        kattokorko.loadYear(defaultYear);

        $.ajax({
            type: 'GET',
            url: Routing.generate('finance_kattokorko'),
            data: {
                loanAmount: loanAmountValue,
                loanPeriod: defaultYear,
            },
            success(data) {
                const loanData = data.kattokorko || {};
                const installment = loanData.monthly_payment !== null && loanData.monthly_payment !== undefined
                    ? commonUtils.numberFormatByLocale(loanData.monthly_payment.toFixed(2))
                    : '-';
                const effective = loanData.apr !== null && loanData.apr !== undefined
                    ? commonUtils.numberFormatByLocale(loanData.apr.toFixed(2))
                    : '-';
                const nominal = loanData.nominal_interest !== null && loanData.nominal_interest !== undefined
                    ? commonUtils.numberFormatByLocale(loanData.nominal_interest.toFixed(2))
                    : '-';

                $('#kattokorko_monthly_payment').html(installment);
                $('#kattokorko_air').html(effective);
                $('#kattokorko_mir').html(nominal);

                setTimeout(kattokorko.removeGreenEffect, 1000);
            },
        });
    },
    submit(object) {
        commonUtils.dataLayer.getLoanButtonDataLayerEvent(object.data('bank-name'));

        const loanAmount = $('#kattokorkoLoanAmount').val();
        const loanYear = $('#kattokorkoLoanPeriod').val();
        const baseUrl = 'https://www.kattokorko.fi/hakemus/kulutusluotto/';
        const queryParams = new URLSearchParams({
            source: '90067',
            amount: loanAmount,
            tenor: loanYear,
        });
        const loanUrl = `${baseUrl}?${queryParams.toString()}`;
        window.open(loanUrl, '_blank');
    },
};
